import { Navigate } from "react-router-dom";
import { useAuth } from "../lib/auth";

export default function RequireRole({ allow, children }) {
  const { profile, loading } = useAuth();
  if (loading) return <div className="p-10 mono text-sm">Loading…</div>;
  if (!profile) return <div className="p-10 mono text-sm">Provisioning profile…</div>;
  if (allow && !allow.includes(profile.role)) {
    return <Navigate to="/app" replace />;
  }
  return children;
}
